<template>
    <div>
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-form ref='queryForm' :inline='true' :model='queryParams' size='small'>
                    <el-form-item label='状态'>
                        <el-select size='mini' clearable v-model="queryParams.status" placeholder="请选择">
                            <el-option
                                v-for="item in statusOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item style='margin-bottom: 0'>
                        <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                        </el-button>
                        <el-button icon='el-icon-refresh' size='mini' @click='reset'>重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='tableDataList'
                      @sort-change='handleSortChange'>
                <el-table-column label='请求Id' width='200' align='center' prop='id' />
                <el-table-column label='发送者' width='250' align='center' prop='senderId' />
                <el-table-column label='接收者' width='250' align='center' prop='receiverId' />
                <el-table-column label='请求状态' align='center'>
                    <template slot-scope='scope'>
                        <el-tag :type='getStatusType(scope.row)' size='mini'>
                            {{getStatusName(scope.row)}}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column width='200' label='附带信息' align='center' >
                    <template slot-scope='scope'>
                        <div class='im-table-content'>
                            {{scope.row.message}}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width='200' sortable='custom' label='创建时间' align='center' prop='createTime' />
                
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-sizes='[5, 15, 30, 45, 60, 75]'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='sizes, prev, pager, next'
                    @size-change='handleSizeChange'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改用户配置对话框 -->
            <el-dialog :visible.sync='open' :title='title' width='40%' append-to-body @close='cancel'>
                <el-form label-width='150'>
                    <el-form-item label="角色">
                        <el-select size='mini' v-model="currentTableData.role" filterable placeholder="请选择">
                            <el-option
                                v-for="item in roleOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select size='mini' v-model="currentTableData.status" filterable placeholder="请选择">
                            <el-option
                                v-for="item in statusOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <div>
                        <el-button type='primary' @click='submitForm'>{{ updateStatus ? '修 改' : '添 加' }}</el-button>
                        <el-button @click='cancel'>取 消</el-button>
                    </div>
                </div>
            </el-dialog>
        
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from '@/utils/message';
import { pageUtil } from '@/utils/pageUtil';
import { deepCopy } from '@/utils/object';
import { imChannelMemberApi } from '@api/Im/ImChannelMemberApi';
import { imFriendRequestApi } from '@api/Im/ImFriendRequestApi';

export default defineComponent({
    name: 'FriendRequest',
    props: {
        projectName: {
            type: String,
        },
        senderId: {
            type: String,
        },
        receiverId: {
            type: String
        }
    },
    data() {
        return {
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 总条数
            total: 0,
            // 弹出层标题
            title: '',
            updateStatus: false,
            // 是否显示弹出层
            open: false,
            
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 5,
                sortSqlList: [
                    'createTime desc'
                ],
                status: undefined
            },
            tableDataList: [],
            currentTableData: {},
            channelMember: {
                openViewDialog: false
            },
            roleOptions: [
                {
                    label: '创建者',
                    value: 0,
                    type: 'success',
                    disabled: true
                },
                {
                    label: '管理者',
                    value: 1,
                    type: 'info'
                },
                {
                    label: '普通成员',
                    value: 2,
                    type: 'warning'
                },
                {
                    label: '游客',
                    value: 3,
                    type: 'warning'
                },
            ],
            statusOptions: [
                {
                    label: '待处理',
                    value: 'PENDING',
                    type: 'info'
                },
                {
                    label: '已被接受',
                    value: 'ACCEPTED',
                    type: 'success',
                },
                {
                    label: '已被拒绝',
                    value: 'REJECTED',
                    type: 'warning'
                },
                {
                    label: '已过期',
                    value: 'EXPIRED',
                    type: 'danger'
                },
            ]
        };
    },
    beforeDestroy() {
        this.tableDataList = []
        this.currentTableData = {}
    },
    computed: {
        getStatusName() {
            return data => {
                if (!data.status) {
                    return ''
                }
                return this.statusOptions.filter(t => t.value === data.status)[0].label
            }
        },
        getStatusType() {
            return data => {
                if (!data.status) {
                    return '未知'
                }
                return this.statusOptions.filter(t => t.value === data.status)[0].type
            }
        },
    },
    created() {
        this.setInitValue();
    },
    methods: {
        reset() {
            this.queryParams = {
                total: 0,
                pageNum: 1,
                pageSize: 5,
                sortSqlList: [
                    'createTime desc'
                ],
                status: undefined
            };
            this.getList();
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        handleAdd() {
            this.updateStatus = false
            this.currentTableData = {}
            this.open = true
            this.title = '新增频道'
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleSizeChange(size) {
            this.queryParams.pageSize = size;
            this.queryParams.pageNum = 1;
            this.getList();
        },
        async handleSortChange({ column, prop, order }) {
            await pageUtil.handleSortChange(prop, order, this.queryParams.sortSqlList);
            this.queryParams.pageNum = 1;
            this.queryParams.pageSize = 15;
            this.getList();
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.getList();
        },
        /** 提交按钮 */
        submitForm: function() {
            if (this.updateStatus) {
                // 修改操作
                imChannelMemberApi.update(this.currentTableData, this.projectName).then(result => {
                    if (result.code === 200) {
                        message.success(result.message)
                        this.open = false
                        this.getList()
                    }
                })
            } else {
            
            }
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.open = true;
            this.title = '修改频道数据';
            this.updateStatus = true;
            this.currentTableData = deepCopy(row);
            this.msgParam = JSON.stringify(this.currentTableData.param, null, 2)
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            let projectName = this.projectName
            this.$modal.confirm('是否从频道中移除"' + row.userId + '"用户？').then(function() {
                return imChannelMemberApi.deleteData(row, projectName)
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        getList() {
            this.queryParams.senderId = this.senderId
            this.queryParams.receiverId = this.receiverId
            this.loading = true;
            imFriendRequestApi.query(this.queryParams, this.projectName).then(result => {
                if (result.code === 200) {
                    if (result.data) {
                        this.tableDataList = result.data.result;
                    }
                    this.queryParams.total = result.data.total;
                    this.queryParams.pageNum = result.data.pageNum;
                    this.queryParams.pageSize = result.data.pageSize;
                }
                this.loading = false;
            })
        },
        setInitValue() {
            this.getList();
        },
        handleChangeStatus(value, data) {
            let channelId = this.channelId
            let projectName = this.projectName
            let msg = value === 1 ? "取消禁言" : '禁言'
            let obj = this
            this.$modal.confirm('是否对该用户执行 ' + msg + ' 操作？').then(function() {
                return imChannelMemberApi.muteMember({channelId: channelId, userId: data.userId, status: value}, projectName);
            }).then((result) => {
                if (result.code === 200) {
                    message.success(result.message)
                    obj.getList()
                }
            }).catch(() => {
            });
        },
        handleChangeRole(value, data) {
            let projectName = this.projectName
            this.$modal.confirm(`是否将用户${data.userId}的角色修改为${this.getRoleName(data)}`).then(function() {
                return imChannelMemberApi.update(data, projectName)
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('修改成功');
                }
            }).catch(() => {
                this.getList()
            });
        }
    }
});
</script>

<style scoped lang='css'>
.im-table-content {
    display: -webkit-box;             /* 使用弹性盒模型 */
    -webkit-box-orient: vertical;    /* 垂直方向排列子元素 */
    -webkit-line-clamp: 4;           /* 限制行数为 4 */
    overflow: hidden;                 /* 隐藏超出的内容 */
    text-overflow: ellipsis;          /* 使用省略号表示超出部分 */
    line-height: 1.5;                 /* 设置行高（可自定义） */
    max-height: calc(1.5em * 4);
}
</style>
